import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c5315d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tickets-wrapper" }
const _hoisted_2 = { class: "tickets-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }

import PFInput from "@/components/Input.vue";
import {ref} from "vue";
import {v4 as uuidv4} from 'uuid';
import {useTickets} from "@/composables/useTickets";
import Ticket from "@/view-models/tickets";
import PFLittleButton from "@/components/LittleButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Tickets',
  setup(__props) {


const {tickets, ticketUpdated} = useTickets();

let ticketName = ref('');

const addedTicket = () => {
  tickets.value.push({
    name: ticketName.value,
    voted: false,
    id: uuidv4(),
    average: '0',
    closest: '0',
    score: '0',
    votingOn: false
  });
  ticketName.value = '';
  ticketUpdated();
}

function deleteTicket(id: string) {
  tickets.value = tickets.value.filter(t => t.id !== id);
  ticketUpdated();
}

function voteOn(ticket: Ticket) {
  for (const value of tickets.value) {
    value.votingOn = false;
  }

  ticket.votingOn = true;
  ticketUpdated();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PFInput, {
      modelValue: _unref(ticketName),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(ticketName) ? (ticketName).value = $event : ticketName = $event)),
      onCompleted: addedTicket,
      placeholder: "Add issue title"
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tickets), (ticket) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createElementVNode("div", {
              class: "ticket",
              onClick: ($event: any) => (voteOn(ticket))
            }, [
              _createElementVNode("h4", {
                class: _normalizeClass({ voting: ticket.votingOn })
              }, [
                _createTextVNode(_toDisplayString(ticket.name) + " ", 1),
                (ticket.score)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(ticket.score), 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createVNode(PFLittleButton, {
                class: "delete-button",
                type: "delete",
                onClicked: ($event: any) => (deleteTicket(ticket.id))
              }, null, 8, ["onClicked"])
            ], 8, _hoisted_3)
          ]))
        }), 256))
      ])
    ])
  ]))
}
}

})